
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import FileUpload from "@common/src/components/scope/file-upload/index.vue";
import t from "@common/src/i18n/t";
import logoSrc from "@/assets/img/speedwork-logo.png";
const marketing = namespace("marketing");
@Component({
  components: { FileUpload }
})
export default class MiniProgramSetting extends Vue {
  @marketing.Action queryMiniProgramQrByStore;
  @marketing.Action updateStoreInfoByWeChat;
  @marketing.Action queryStoreInfoByWeChat;

  settingForm = {
    id: "defalut",
    closingTime: "",
    openingTime: "",
    servicePhone: "",
    storePhoto: [],
    openReservation: 1,
    businessHours: ["0900", "1700"],
    SaturdayHours: ["0900", "1700"],
    SundayHours: ["0900", "1700"],
    monToFriday: {
      scheduleDayOfWeek: "8",
      scheduleEndHour: "",
      scheduleStartHour: "",
      scheduleType: 1,
      status: 1
    },
    saturday: {
      scheduleDayOfWeek: "6",
      scheduleEndHour: "",
      scheduleStartHour: "",
      scheduleType: 1,
      status: 1
    },
    sunday: {
      scheduleDayOfWeek: "7",
      scheduleEndHour: "",
      scheduleStartHour: "",
      scheduleType: 1,
      status: 1
    }
  };
  storeQrUrl: string = "";
  qrCanvas = null;
  settingFormRules = {
    storePhoto: {
      type: "array",
      required: true,
      message: t("v210831.please-upload-store-img"),
      trigger: "change"
    },
    businessHours: {
      type: "array",
      required: true,
      message: t("v210831.please-select-business"),
      trigger: "change"
    },
    servicePhone: { required: true, message: t("v210831.please-enter-external"), trigger: "blur" },
    openReservation: { required: true, message: t("v210831.please-select-whether-or-subscribe"), trigger: "blur" },
    openSpeedWork: { required: true, message: t("v210831.please-select-whether-or-subscribe"), trigger: "blur" }
  };
  created() {
    this.init();
  }
  photoDefaultList = [];
  init() {
    const p1 = this.queryStoreInfoByWeChat().then(data => {
      // 处理时间
      Object.assign(this.settingForm, data.data);
      const { monToFriday, saturday, sunday } = data.data;
      this.settingForm.SundayHours = [sunday.scheduleStartHour, sunday.scheduleEndHour];
      this.settingForm.businessHours = [monToFriday.scheduleStartHour, monToFriday.scheduleEndHour];
      this.settingForm.SaturdayHours = [saturday.scheduleStartHour, saturday.scheduleEndHour];
      if (data.data?.storePhoto?.length) {
        this.photoDefaultList = data.data.storePhoto.map(item => ({ url: item }));
      }
    });
    const p2 = this.queryMiniProgramQrByStore().then(data => {
      this.storeQrUrl = data.data;
    });
    Promise.all([p1, p2]).then(() => {
      this.initStoreQr();
    });
  }

  submitForm() {
    (this.$refs.settingForm as any).validate(valid => {
      if (valid) {
        this.settingForm.saturday.scheduleStartHour = String(this.settingForm.SaturdayHours[0]);
        this.settingForm.sunday.scheduleStartHour = String(this.settingForm.SundayHours[0]);
        this.settingForm.sunday.scheduleEndHour = String(this.settingForm.SundayHours[1]);
        this.settingForm.monToFriday.scheduleEndHour = String(this.settingForm.businessHours[1]);
        this.settingForm.saturday.scheduleEndHour = String(this.settingForm.SaturdayHours[1]);
        this.settingForm.monToFriday.scheduleStartHour = String(this.settingForm.businessHours[0]);
        this.updateStoreInfoByWeChat(this.settingForm).then(() => {
          this.$message.success(t("v210831.saved-successfully"));
        });
      }
    });
  }
  handleDownloadQr() {
    const imageUrl = this.qrCanvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = "store.png";
    link.click();
  }
  handleBannerUploadSuccess() {
    (this.$refs.settingForm as any).validateField("storePhoto");
  }
  // 超过一行换行，超过两行显示...
  drawTextWithWrap(ctx, text, x, y, maxWidth, lineHeight) {
    let lineNum = 0; // 文本的行数
    let noSpace = text.split(" ").length === 1; // 处理语言带空格和不带空格的
    const maxLineNum = 2; // 显示的最大行数
    const words = noSpace ? text.split("") : text.split(" ");
    let line = "";
    for (let n = 0; n < words.length; n++) {
      const testLine = line + words[n] + (noSpace ? "" : " ");
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        if (lineNum >= maxLineNum - 1) {
          lineNum++;
          break;
        } else {
          ctx.fillText(line, x, y);
          lineNum++;
          if (n < words.length - 1) {
            line = words[n] + " ";
          } else {
            line = words[n];
          }
          y += lineHeight;
        }
      } else {
        line = testLine;
      }
    }
    ctx.fillText(lineNum >= maxLineNum ? line.slice(0, -3) + "..." : line, x, y);
    lineNum++;
    console.log(Math.min(lineNum, maxLineNum), "行数");
    return Math.min(lineNum, maxLineNum);
  }

  initStoreQr() {
    this.$nextTick(() => {
      const canvas: any = document.getElementById("storeQrUrl");
      const ctx = canvas.getContext("2d");
      const width = 750 / 3; // 按设计稿三倍放小
      const height = 1024 / 3;
      const dpr = 3;
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      ctx.scale(dpr, dpr);

      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = "#009146";
      ctx.fillRect(0, 0, canvas.width, 840 / 3);

      ctx.fillStyle = "#fff";
      ctx.font = "bold 16px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "top";
      const x = canvas.width / 2 / dpr; // 水平居中
      ctx.fillText("SPEEDWORK CLUB,", x, 70 / 3);

      ctx.fillStyle = "#fff";
      ctx.font = "14px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "top";
      const lineNum = this.drawTextWithWrap(ctx, String(this.$t("v3_7_0.trusted-car-care")), x, 140 / 3, 750 / 3, 18);

      ctx.fillStyle = "#fff";
      ctx.fillRect(165 / 3, 155 / 3 + lineNum * 18, 420 / 3, 420 / 3);
      const img = new Image();
      img.src = this.storeQrUrl;
      img.crossOrigin = "anonymous";
      img.onload = function () {
        ctx.drawImage(img, 185 / 3, 175 / 3 + lineNum * 18, 380 / 3, 380 / 3);
      };

      ctx.fillStyle = "#fff";
      ctx.font = "12px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "top";
      this.drawTextWithWrap(ctx, (this.settingForm as any).storeName, x, 620 / 3 + lineNum * 18, 750 / 3, 18);

      const logo = new Image();
      logo.src = logoSrc;
      logo.onload = function () {
        ctx.drawImage(logo, 182 / 3, 880 / 3, 386 / 3, 103 / 3);
      };
      this.qrCanvas = canvas;
    });
  }
}
